module.exports = __webpack_public_path__ + "img/resourceImageThree.3aa52895.png";